export default __webpack_public_path__ + "/dist/images/5790218.7a408f6081cf0b00f44bd7b6469a942b.png";